import { setAppNavigateMode } from 'common/actions';
import { store } from 'index';

export type NavigateMode = 'DIRECTIONAL' | 'POINTER';

type NavigateModeListener = (mode: NavigateMode) => void;

class NavigateModeEventEmitter {
  private currentMode: NavigateMode;
  private listeners: Set<NavigateModeListener> = new Set();

  constructor(initialMode: NavigateMode = 'DIRECTIONAL') {
    this.currentMode = initialMode;
  }

  get mode(): NavigateMode {
    return this.currentMode;
  }

  setMode(mode: NavigateMode) {
    if (this.currentMode !== mode) {
      this.currentMode = mode;
      this.emit(mode);
      store.dispatch(setAppNavigateMode(mode));
    }
  }

  on(listener: NavigateModeListener) {
    this.listeners.add(listener);
  }

  off(listener: NavigateModeListener) {
    this.listeners.delete(listener);
  }

  private emit(mode: NavigateMode) {
    this.listeners.forEach((listener) => listener(mode));
  }
}

export default new NavigateModeEventEmitter();
